import * as React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { createStructuredSelector } from 'reselect';
import { push } from 'connected-react-router';

// Global Types
// TODO
// import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { setSelectedTableCell } from 'services/selectedTableCells/actions';

// Selectors
// @ts-ignore
import { makeSelectTimesheetEntryValue } from 'services/timesheetEntries/selectors';

// Component Types
import { OwnProps, ConnectedProps, Props } from './types';

export class TimesheetEntryTableRowLink extends React.PureComponent<Props> {
    handleClick = (): void => {
        const { timesheetEntryUuid, timesheetId } = this.props;

        if (timesheetId) {
            this.props.setSelectedTableCell(timesheetEntryUuid);

            this.props.push(`/organization/time/timesheets/${timesheetId}`);
        }
    };

    render(): React.ReactElement {
        const { children } = this.props;
        return (
            <Table.Row
                onClick={this.handleClick}
                // HACK: inline style
                style={{
                    cursor: 'pointer'
                }}
            >
                {children}
            </Table.Row>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    any, // TODO replace with AppState,
    OwnProps,
    ConnectedProps
>({
    timesheetId: makeSelectTimesheetEntryValue('timesheetId')
});

export default connect(
    mapStateToProps,
    { push, setSelectedTableCell }
)(TimesheetEntryTableRowLink);
